import { AxiosStatic } from "axios";

export enum ResolvableType {
  Organization = "org",
  Account = "acc",
  Class = "cls",
  Course = "crs",
  CourseInstance = "cin",
  FontFamily = "ffm",
  Group = "grp",
  ScormPackage = "sco",
  Style = "sty",
}

export type GenericResolveFn<T = any> = (
  activeUserUuid: string,
  uuids: Array<[ResolvableType, string] | string>,
  activeOrganizationId?: string
) => Promise<T>;

export interface IResolveApiDependencies {
  axios: AxiosStatic;
  saltcomplianceApiRoot: string;
}

export interface IResolveResponse<T> {
  code: number;
  value: T;
}

export interface IResolveError {
  code: number;
  error: string;
}

interface IOrgDisplayResponse {
  canonicalAlias?: string;
  deleted: boolean;
  displayName: string;
  locked: boolean;
  owner: string;
}

interface ICourseInstPreviewResponse {
  accountId: string;
  completed: boolean;
  courseId: string;
  courseRevId: number;
  isValid: boolean;
  logicVersion: number;
  numResets: number;
}

export type IOrgDisplayData = IResolveResponse<IOrgDisplayResponse>;
export type ICourseInstPreviewData = IResolveResponse<ICourseInstPreviewResponse>;

type OrgId = string;

export interface IAlias {
  kind: string;
  name: string;
}

export interface IDisplayInfoResponse {
  canonicalAlias: IAlias | null;
  deleted: boolean;
  displayName: string | null;
  locked: boolean;
  owner: OrgId;
}

export interface IOrganizationDisplayInfo extends IDisplayInfoResponse {
  organizationId: string;
}

export interface IOrganizationTree extends IOrganizationDisplayInfo {
  children: IOrganizationTree[];
}
